<template>
  <v-alert
    v-if="hasDifferentTimeZone"
    border="bottom"
    elevation="5"
    color="orange"
    type="error"
  >
    {{ messageText }}
  </v-alert>
</template>

<script>
import { UtcDate, ExtDate } from '@/helpers/date';

export default {
  name: 'time-zone-warning',
  props: {
    messageText: {
      type: String,
      default: "Due to a difference in your current time zone and our website's time zone, you may see an unexpected date error here. Please review or return later.",
    },
    questionDate: {
      type: String,
      default: null,
    },
  },

  computed: {
    hasDifferentTimeZone () {
      if (!this.questionDate) return false;
      const today = new ExtDate();
      const todayUtc = new UtcDate();
      const hasDayDifference = today.differenceInCalendarDays(todayUtc) === 1;
      return hasDayDifference && this.checkTimeZoneDifference(this.questionDate);
    },
  },

  methods: {
    checkTimeZoneDifference (value) {
      const currentUtcDate = new UtcDate();
      const passedUtcDate = new UtcDate(value);
      const hasYearDifference = currentUtcDate.differenceInYears(passedUtcDate);

      if (hasYearDifference) {
        const hasMonthDifference = currentUtcDate.getMonth() === passedUtcDate.getMonth();
        const hasDayDifference = passedUtcDate.getDate() - currentUtcDate.getDate() === 1;

        return hasMonthDifference && hasDayDifference;
      }

      return passedUtcDate.differenceInCalendarDays(currentUtcDate) === 1;
    },
  },
};
</script>
